export interface PossibleTypesResultData {
  possibleTypes: {
    [key: string]: string[];
  };
}
const result: PossibleTypesResultData = {
  possibleTypes: {
    BaseReport: [
      'DetailedDataReport',
      'ReachFrequencyReport',
      'Report',
      'StandardDeliveryDeviceHigherCategoryReport',
      'StandardDeliveryReport',
      'TopLineGenreDeliveryReport',
    ],
    BrunoBaseReport: [
      'AllCampaignsCreateReportResponse',
      'AllCampaignsReport',
      'BrunoCreateDetailedReportReportResponse',
      'BrunoDetailedReportReport',
      'CuratedAudienceUsageReport',
      'DeliveryPerformanceReport',
      'DeliveryPerformanceReportResponse',
    ],
    Connection: [
      'AdAccountAudienceTargetValuePages',
      'AdAccountsOptionsPages',
      'AdAccountsOptionsWithNotificationTypesPages',
      'AdAccountsPages',
      'AdsList',
      'BillingContactsPage',
      'BrandsPage',
      'BroadcastPage',
      'BroadcastersList',
      'BrunoDetailedReportsPage',
      'BrunoReportsPage',
      'CampaignsOptions',
      'CampaignsPage',
      'CampaignsPageWithExtraData',
      'CampaignsShortInfoPage',
      'DimensionValuePages',
      'GetUsersPage',
      'InvoicePage',
      'LateLinesPage',
      'NotificationPage',
      'OrganizationsList',
      'PaymentsList',
      'ReachFrequencyReportMetricsPage',
      'SearchUsersPage',
      'StandardDeliveryDeviceHigherCategoryReportMetricsPage',
      'StandardDeliveryReportMetricsPage',
      'TopLineGenreDeliveryReportMetricsPage',
      'TransactionHistoryPage',
      'UsersPage',
    ],
    Edge: [
      'AdAccountAudienceTargetValueEdge',
      'AdAccountEdge',
      'AdAccountOptionsEdge',
      'AdAccountOptionsWithNotificationTypeEdge',
      'AdEdge',
      'BillingContactEdge',
      'BrandEdge',
      'BroadcastEdge',
      'BroadcasterEdge',
      'BrunoDetailedReportEdge',
      'BrunoReportEdge',
      'CampaignEdge',
      'CampaignEdgeWithExtraData',
      'CampaignOptionsEdge',
      'CampaignShortInfoEdge',
      'DimensionValueEdge',
      'GetUsersEdge',
      'InvoiceEdge',
      'LateLineEdge',
      'NotificationEdge',
      'OrganizationEdge',
      'PaymentsEdge',
      'ReachFrequencyReportMetricsEdge',
      'SearchUserEdge',
      'StandardDeliveryDeviceHigherCategoryReportMetricsEdge',
      'StandardDeliveryReportMetricsEdge',
      'TopLineGenreDeliveryReportMetricsEdge',
      'TransactionHistoryEdge',
      'UserEdge',
    ],
    EntityName: ['AdAccountRole', 'GenericRole'],
    LineItemInterface: ['InfoMetricsLineItem', 'LineItem'],
    Node: [
      'AdAccount',
      'AdAccountAudienceTargetValue',
      'AdAccountOptions',
      'AdAccountWithNotificationTypeOptions',
      'AdInfo',
      'Audiences',
      'BillingContact',
      'Brand',
      'Broadcast',
      'Broadcaster',
      'BrunoDetailedReportInfo',
      'BrunoReportInfo',
      'CampaignInfo',
      'CampaignInfoWithExtraData',
      'CampaignOption',
      'CampaignShortInfo',
      'CustomAudienceById',
      'DimensionValue',
      'GetUsersNode',
      'Invoice',
      'LateLine',
      'Notification',
      'OrganizationListItem',
      'PaymentMethod',
      'ReachFrequencyReportMetrics',
      'SearchUser',
      'StandardDeliveryDeviceHigherCategoryReportMetrics',
      'StandardDeliveryReportMetrics',
      'TopLineGenreDeliveryReportMetrics',
      'TransactionHistory',
      'User',
    ],
    ReportFilters: [
      'DetailedDataReportFilters',
      'ReachFrequencyReportFilters',
      'StandardDeliveryDeviceHigherCategoryReportFilters',
      'StandardDeliveryReportFilters',
      'TopLineGenreDeliveryReportFilters',
    ],
    SharedStandardDeliveryReportFilters: [
      'StandardDeliveryDeviceHigherCategoryReportFilters',
      'StandardDeliveryReportFilters',
    ],
    VastInterface: ['QCheckVast'],
  },
};
export default result;
